import { mapState, mapActions } from 'vuex'
import OrdersStatisticsModal from '@/components/modals/orders-statistics-modal/orders-statistics-modal.vue'
import Loader from '@/components/loader/loader.vue'

import { numberWithSeparator } from '@/utils/format-strings'

export default {
  name: 'CitySummary',
  props: {
    cityInfo: {
      /**
       * структура в ответе на запрос https://dosta-admin.apidoc.handh.ru/#operation/v2MainTodayResults
       * в поле cities
       */
      type: Object,
      required: true
    }
  },
  components: {
    OrdersStatisticsModal,
    Loader
  },
  data() {
    return {
      isModalShow: false,
      loadingEpxpressAnalysis: false,
      dataStatistics: null
    }
  },
  computed: {
    ...mapState({
      cities: state => state.manufactures.cities,
      selectedCity: state => state.manufactures.selectedCity,
      pageLoading: state => state.pageLoader.loading
    })
  },
  methods: {
    ...mapActions({
      getAllSharedData: 'sharedData/getAllSharedData',
      setSelectedCityAction: 'manufactures/setSelectedCity',
      setSelectedAreasAction: 'manufactures/setSelectedAreas',
      getExpressAnalysys: 'regionOrders/getExpressAnalysys'
    }),

    numberWithSeparator,

    getCityToRequests() {
      if (this.cityInfo.city_id === this.selectedCity.city_id) {
        return this.selectedCity
      }
      return this.cities.find(city => city.city_id === this.cityInfo.city_id)
    },

    async setCityStore() {
      if (this.cityInfo.city_id === this.selectedCity.city_id) {
        await this.setSelectedAreasAction(this.selectedCity.areas)
        return
      }
      const cityToRequests = this.getCityToRequests()
      if (cityToRequests) {
        await this.setSelectedCityAction(cityToRequests)
      }
    },

    async goToManufactures() {
      await this.setCityStore()
      this.$router.push({
        name: 'dashboard-manufactures'
      })
    },

    async fetchExpressAnalysys() {
      const cityToRequests = this.getCityToRequests()
      try {
        this.loadingEpxpressAnalysis = true
        this.dataStatistics = await this.getExpressAnalysys(cityToRequests)
      } finally {
        this.loadingEpxpressAnalysis = false
      }
    },

    onHideStatiscticModal() {
      this.isModalShow = false
    },

    async showExpressAnalisys() {
      await this.fetchExpressAnalysys()
      this.isModalShow = true
      this.$refs['orders-statistics-modal'].show()
    }
  }
}